// Spanish shared across many screens. English text (exact) -> Spanish.
// Area files (home.js, clock.js, ...) can repeat or override these.
const dict = {
  "Español": "Español",
  "English": "English",
  "Save": "Guardar",
  "Saving...": "Guardando...",
  "Cancel": "Cancelar",
  "Close": "Cerrar",
  "Yes": "Sí",
  "No": "No",
  "OK": "OK",
  "Edit": "Editar",
  "Delete": "Eliminar",
  "Remove": "Quitar",
  "Add": "Agregar",
  "Back": "Atrás",
  "Next": "Siguiente",
  "Submit": "Enviar",
  "Send": "Enviar",
  "Search": "Buscar",
  "Search...": "Buscar...",
  "Loading...": "Cargando...",
  "Try again": "Intentar de nuevo",
  "Today": "Hoy",
  "Tomorrow": "Mañana",
  "Yesterday": "Ayer",
  "This Week": "Esta Semana",
  "Date": "Fecha",
  "Time": "Hora",
  "Notes": "Notas",
  "Note": "Nota",
  "Status": "Estado",
  "Total": "Total",
  "Name": "Nombre",
  "Address": "Dirección",
  "City": "Ciudad",
  "State": "Estado",
  "Phone": "Teléfono",
  "Email": "Correo electrónico",
  "Password": "Contraseña",
  "N/A": "N/D",
  "None": "Ninguno",
  "Unknown": "Desconocido",
  "Unassigned": "Sin asignar",
  "Active": "Activo",
  "Completed": "Completado",
  "Pending": "Pendiente",
  "Approved": "Aprobado",
  "Denied": "Rechazado",
  "On Hold": "En Espera",
  "Invoice Sent": "Factura Enviada",
  "Sun": "Dom",
  "Mon": "Lun",
  "Tue": "Mar",
  "Wed": "Mié",
  "Thu": "Jue",
  "Fri": "Vie",
  "Sat": "Sáb",
  "Translated": "Traducido",
  "Show original": "Ver original",
  "Show translation": "Ver traducción",
  "Translating…": "Traduciendo…",
};

export default dict;
